module.exports = __webpack_public_path__ + "img/bg2.685cf934.png";